/**
 * BrandHeader — Sidebar section [1]: logo + tool name.
 *
 * Standard implementation. Tool can replace with a custom one if needed,
 * but this default works for most cases.
 */

import { BaseSection, type SectionId } from '@/core/BaseSection';

export class BrandHeader extends BaseSection {
  readonly sectionId: SectionId = 'brand';
  readonly sectionTitle = 'Brand';

  private nameEl!: HTMLElement;
  private taglineEl!: HTMLElement;

  protected async onInit(): Promise<void> {
    this.element.innerHTML = `
      <div class="brand-header">
        <div class="brand-logo" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
            <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
            <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
          </svg>
        </div>
        <div class="brand-text">
          <span class="brand-name"></span>
          <span class="brand-tagline"></span>
        </div>
      </div>
    `;

    this.nameEl = this.element.querySelector('.brand-name')!;
    this.taglineEl = this.element.querySelector('.brand-tagline')!;

    this.render();
  }

  protected onLocaleChange(): void {
    this.render();
  }

  private render(): void {
    this.nameEl.textContent = this.context.i18n.t('app.name');
    this.taglineEl.textContent = this.context.i18n.t('app.tagline');
  }
}
